/* import __COLOCATED_TEMPLATE__ from './priority-divider.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();